import { TYPES } from "@atresmedia/elections_modules_library";

export const MODULE_TYPES = {
  RESULTADOS: "Resultados",
  PACTOMETRO: "Pactometro",
  RESULTADOS_DOBLES: "Resultados Dobles",
  RANKING: "Ranking",
  BARRAS: "Comparativa de escaños",
  MINI: "Suma de bloques",
  BUTTONS: "Generador de enlaces"
};

export const MODULES_A3 = {
  RESULTADOS: "Resultados",
  PACTOMETRO: "Pactometro",
  BARRAS: "Comparativa de escaños",
  BUTTONS: "Generador de enlaces"
};

export const MODULES_LASEXTA_G = {
  RESULTADOS: "Resultados",
  PACTOMETRO: "Pactometro",
  RANKING: "Ranking",
  MINI: "Suma de bloques",
  BUTTONS: "Generador de enlaces"
};

export const MODULES_LASEXTA_PV = {
  RESULTADOS: "Resultados",
  PACTOMETRO: "Pactometro",
  RANKING: "Ranking",
  BUTTONS: "Generador de enlaces"
};

export const MODULES_ONDACERO = {
  RESULTADOS: "Resultados",
  PACTOMETRO: "Pactometro",
  BUTTONS: "Generador de enlaces"
};

export const DOUBLE_MODULE = {
  RESULTADOS_DOBLES: "Resultados Dobles"
};

export const LOCALHOST = "localhost";
export const LA_SEXTA = "lasexta";
export const ANTENA3 = "antena3";
export const ONDACERO = "ondacero";
export const SITES = [LA_SEXTA, ANTENA3, ONDACERO];
export const NO = "No navegable";
export const NEWS = "Navegable news";
export const STATIC = "Navegable static";
export const NAV = [NO, NEWS, STATIC];
export const isOndaCero = site =>
  site === ONDACERO || window.location.hostname.includes(ONDACERO);
export const isAntena3 = site =>
  site === ANTENA3 || window.location.hostname.includes(ANTENA3);
export const isLaSexta = site =>
  site === LA_SEXTA || window.location.hostname.includes(LA_SEXTA);

export const getSite = () =>
  window.location.hostname.includes(ONDACERO)
    ? ONDACERO
    : window.location.hostname.includes(ANTENA3)
    ? ANTENA3
    : window.location.hostname.includes(LA_SEXTA)
    ? LA_SEXTA
    : "";

const basename = process.env.PUBLIC_URL || "/";

export const getModuleAmp = (url, height = 800, urlImg) =>
  `<amp-iframe 
  width="750" 
  height="${height}" 
  sandbox="allow-popups allow-scripts allow-same-origin" 
  layout="responsive" 
  frameborder="0"
  style="height: ${height}px"
  src="${window.location.href.replace("/generador.html", url)}#amp=1">
    <amp-img 
      placeholder 
      layout="fill"
      src="${urlImg}">
    </amp-img>
</amp-iframe>`;

export const getModuleWeb = (moduleId, url) =>
  `<div id="${moduleId}"></div>
  
<script>
var cssId = "myCss"; // you could encode the css path itself to generate id..
var scriptId = "myScript"; // you could encode the css path itself to generate id..
if (!document.getElementById(cssId)) {
  var head = document.getElementsByTagName("head")[0];
  var link = document.createElement("link");
  link.id = cssId;
  link.rel = "stylesheet";
  link.type = "text/css";
  link.href = "${basename}/static/css/main.css";
  link.media = "all";
  head.appendChild(link);

  var script = document.createElement("script");
  script.setAttribute(
    "src",
    "${basename}/static/js/main.js"
  );
  script.id = scriptId;
  script.onload = function() {
    document.dispatchEvent(new CustomEvent("script-load"));

    window.atresmedia_elecciones(document.getElementById('${moduleId}'),"${url}")

  };
  document.body.appendChild(script);
} else {
  document.addEventListener("script-load", function(e) {
    window.atresmedia_elecciones(document.getElementById('${moduleId}'),"${url}")

  });
}
</script>`;
